import {eventsApi} from './../../api';
import {collection, computed} from './state';
import {flattenByProp, removeFromArray} from './../../utils';


import {Event, EventAPIReturnOptions, EventAPIConfig, DropdownOption, EventStatus, EventStatusEmoji, TeamObject, EventPlayer, EventSlot, Player, EventController, Squadron, TeamSlot, EventProto, EventDetailsProto} from './../../interfaces';
import dayjs from 'dayjs';
dayjs().format();

import App from '~/core/app'
import { ICore } from '~/core/core'; // type from the future
import { devLog } from '~/assets/js/helpers';
import { isEqual, union, xor } from 'lodash';
const core = App.Core<ICore>(); // grab sister controller

function organizeEvent(event: Event){
	// backend stores timestamps in sec not ms, this is the conversion to the js default of ms
	event.date = 1000 * (event.date||Date.now());
	
	// if (event.date < Date.now()){
	// 	event.status = 'COMPLETED';
	// }
	if(event.isPublished) {
		collection.collect(event, ['published', 'default']); // The event will always be published if we get in this scope 
	}
	else{ 
		collection.collect(event, ['pending', 'default']); // The event will always be not published if we get in this scope
	}
}

/**
 * 
 * @param id The event id you would like to patch
 * @param eventData The event data you would like to patch
 */
export function patchEvent(id: number, eventData: EventProto){
	const existingEvent = collection.getDataValue(id)
	const newEvent = Object.assign(existingEvent, eventData)
	const newExistingEvent = collection.getDataValue(id)
	
	if(isEqual(existingEvent, newExistingEvent)){devLog('SAME INSTANCE').info()}
	// collection.update(id, newEvent, {deep: true})
	core
	devLog(existingEvent, " => ", newEvent, "=>:", collection.getDataValue(id)).info()
}

export const recompute = () => Object.values(computed).forEach(computedObj => computedObj.recompute());
export const getProp = (propName: string) => collection.selectors.focused.value[propName];
export function emitTreeUpdate(){
	core.events.events.reloadTree.emit()
}
export async function createEvent(eventConfig): Promise<Event> {
	try{
		eventConfig.date = Math.floor(eventConfig.date / 1000)
		let event: Event = <Event>(await eventsApi.genEvent(eventConfig)).data.value
		organizeEvent(event)
		return event;
	} catch (err) {
		console.error(err)
		throw err;
	}
}
export async function findPlayer(playerName: string): Promise<Player|Player[]>{
	try{
		const players: Player[] = <Player[]>(await eventsApi.findPlayer(playerName)).data.value
		if(!players || playerName.length <= 0) throw new Error(`Can't find the player`)
		if(players.length === 1){
			return players[0];
		}
		else {
			return players;
		}
	} catch (err) {
		console.error(err)
		throw err;
	}
}
export async function getEventById(id: number, returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		const payload: EventAPIConfig = {
			data: {
				id
			},
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		}
		let event: Event = <Event>(await eventsApi.getEvent(payload)).data.value;
		event.date = 1000 * (event.date || Date.now());
		let old_event = collection.findById(id)
		if(old_event){
			collection.update(id, event, {deep: true})
		}
		else organizeEvent(event);

		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function patchEventById(id: number, returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		let event: Event = <Event>(await eventsApi.getEvent({
			data: {
				id
			}, 
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		})).data.value;
		// event.date = 1000 * event.date;
		// console.log(event)
		let old_event = collection.findById(id).value
		if(old_event){
			collection.update(id, {...event, ...old_event})
		}
		else organizeEvent(event);
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function updateEventDetails(id: number, details: EventDetailsProto, returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		// details = normalizeEventDetails(id)
		patchEvent(id, details);
		
		if (details.date) details.date = Math.floor(details.date / 1000)
		const event: Event = <Event>(await eventsApi.patchEventDetails({
			data: {
				id,
				...details
			}, 
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		})).data.value;
		event.date = 1000 * event.date;
		// console.log(event)
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function updateEventStructure(id: number, slots: EventSlot[], structure: TeamObject[], returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		
		const event: Event = <Event>(await eventsApi.patchEventStructure({
			data: {
				id,
				slots,
				structure
			}, 
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		})).data.value;
		event.date = 1000 * event.date;
		patchEvent(id, {slots: event.slots, structure: event.structure});
		// console.log(event)
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function updateEventPlayers(eventId: number, players: EventPlayer[], returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		
		// patchEvent(eventId, {players: union(collection.getDataValue(eventId).players, players)});
		addPlayer(players[0])
		const event: Event = <Event>(await eventsApi.patchEventPlayers({
			data: {
				id: eventId,
				players
			}, 
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		})).data.value;
		// console.log(event)
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function  removeEventSlots(eventId: number, slots: TeamSlot[]=[], returns=eventsApi.EventAPIReturnOptions.FULL): Promise<Event> {
	try{
		slots.forEach(slot => {
			removeSlot(slot.id)
		})
		console.log("slots: ", slots)
		if(!Array.isArray(slots)){throw new Error('You must provide an array of slots to remove.')}
		const event: Event = <Event>(await eventsApi.deleteEventSlot({
			data: {
				id: eventId,
				slots,
				structure: collection.selectors.focused.value.structure
			}, 
			config: {
				return: returns
			}
		})).data.value;
		if(event){ event.date = 1000 * event.date }
		console.log(event)
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function  removeEventPlayers(eventId: number, players: EventPlayer[], returns?: EventAPIReturnOptions): Promise<Event> {
	try{
		const event: Event = <Event>(await eventsApi.deleteEventPlayers({
			data: {
				id: eventId,
				players
			}, 
			config: {
				return: returns||eventsApi.EventAPIReturnOptions.FULL
			}
		})).data;
		// if(event){ event.date = 1000 * event.date }
		console.log(event)
		return event;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function  getEvents(): Promise<Event[]>{
	try{
		let events: Event[] = <Event[]>(await eventsApi.getEvents()).data
		return events;
	} catch (err) {
		console.error(err);
		throw err;
	}
}
export async function fetchEvents(): Promise<void>{
	try{
		const res = (await eventsApi.getEvents())
		if(res.status > 299 || res.data.error) throw res.data.error
		let events: Event[] = res.data.value
		events.forEach(event => {
			organizeEvent(event);
		})
	} catch (err) {
		// console.error(err);
		throw err;
	}
}
export async function getSquadrons(){
	const res = (await eventsApi.getSquadrons())

	return res.data.value
}

export function getEventStatus(_status: string): string {
	let stat = EventStatus[_status]
	return stat||'N/A';
}

export function getEventStatusEmoji(_status: string): string {
	let stat = EventStatusEmoji[_status]
	return stat||'N/A';
}

export function createTeam(name: string, parentId: number): TeamObject{
	
	if(collection.selectors.focused.value.structure && Array.isArray(collection.selectors.focused.value.structure)){
		// find the next id
		let arrayOfIds = flattenByProp(collection.selectors.focused.value.structure, 'id')
		const parent = collection.selectors.focused.value.structure.find(team => team.id === parentId);
		parent?.children
	}
	
	return <TeamObject>{
		name,
		
	};
	

}

export function removePlayer(id: string){
	if(!id) {throw new Error("No ID was passed, can't remove player");}
	
	const newPlayers = removeFromArray(collection.selectors.focused.value.players, (player) => player.playerId === id)
	collection.selectors.focused.value.players.length = 0
	collection.selectors.focused.value.players.push(...newPlayers)
	
}
export function addPlayer(newPlayer: EventPlayer){
	const _newPlayer = Object.assign({}, newPlayer)
	const playerIndex = collection.selectors.focused.value.players.findIndex((player) => player.playerId === _newPlayer.playerId)
	console.log('Adding/Updating player...')
	if(playerIndex === -1){
		collection.selectors.focused.value.players.push(_newPlayer)
	}
	else{
		Object.assign(collection.selectors.focused.value.players[playerIndex], _newPlayer)
	}
	
}


export function addSlot(newSlot: TeamSlot, parentId: number){
	const _new = Object.assign({}, newSlot)
	const slotIndex = collection.selectors.focused.value.slots.findIndex((slot) => slot.id === _new.id)
	devLog('Adding/Updating slot...').info(true)
	// adding it to the slots array
	if(slotIndex === -1){
		collection.selectors.focused.value.slots.push(_new)
	}
	else{
		Object.assign(collection.selectors.focused.value.slots[slotIndex], _new)
	}
	// adding it to the slots in the team
	flattenByProp<TeamObject>(collection.selectors.focused.value.structure||[])
		.find(group => Number(group.id) === parentId).slots.push(_new.id)
	
}


export const getPlayerBySlot = (slotId: number): EventPlayer|undefined => collection.selectors.focused.value.players?.find(player => player.slotId === slotId)
export const getSlotById = (id: number): EventSlot|undefined => collection.selectors.focused.value.slots?.find(slot => slot.id === id)
export const getTeamBySlot = (slotId: number): TeamObject|undefined => flattenByProp(collection.selectors.focused.value.structure)?.find(
	group => group.slots?.find(
		slot => slot === slotId
	)
)
export const getPlayerById = (playerId) => collection.selectors.focused.value.players.find(player => player.playerId === playerId)
export function switchSlots(slotId1: number, slotId2: number){
	devLog('Switching players slots...', slotId1, slotId2).info()
	const player1: EventPlayer|undefined = getPlayerBySlot(slotId1)
	const player2: EventPlayer|undefined = getPlayerBySlot(slotId2)
	if(player1 && player2){
		devLog('Found players associated with slots...', {...player1}, {...player2}).info()
		const player1_reserve = Object.assign({}, player1)
		player1.slotId = player2.slotId
		if(player1.role) {player1.role = player2.role}

		player2.slotId = player1_reserve.slotId
		if(player2.role) {player2.role = player1_reserve.role}

		addPlayer(player1); // apply changes to pulse
		addPlayer(player2); // apply changes to pulse
		devLog('Modified players...', {...player1}, {...player2}).info()
	}
	else if(player1 && !player2){
		player1.slotId = player2.slotId;
		if(player1.role) {player1.role = player2.role}
		addPlayer(player1); // apply changes to pulse
		// because the second slot was an empty one
	}

	return [player1, player2]
	
}
export const getTeamById = (teamId: number) => flattenByProp<TeamObject>(collection.selectors.focused.value.structure).find(team => team.id === teamId)

export function removeSlot(slotId: number): TeamSlot{
	if(slotId === null || slotId === undefined) {throw new Error("No ID was passed, can't remove slot");}
	const removedSlot: TeamSlot = {...collection.selectors.focused.value.slots.find(slot => slot.id === slotId)};
	const newSlots = removeFromArray(collection.selectors.focused.value.slots, slot => slot.id === slotId)
	collection.selectors.focused.value.slots.length = 0;
	collection.selectors.focused.value.slots.push(...newSlots)
	// console.log('slots in here!: ', collection.selectors.focused.value.slots)
	const foundGroup: TeamObject = getTeamBySlot(slotId)
	if (foundGroup) { 
		const newGroupSlots = removeFromArray(foundGroup.slots, _slotId => _slotId === slotId) 
		foundGroup.slots.length = 0
		foundGroup.slots.push(...newGroupSlots)
	}
	

	console.log(`removed slot ${slotId} from event`)

	const player = getPlayerBySlot(slotId)
	if(player){
		removePlayer(player.playerId)
	}
	return removedSlot;
}

export function deleteTeam(teamId: number){
	const teamToDelete = flattenByProp<TeamObject>(collection.selectors.focused.value.structure)?.find((team: TeamObject) => team.id === teamId)
	const removeTeamFromStructure = (teamToDelete: TeamObject, struct: TeamObject[]): boolean => {
		let found = false;

		if(!Array.isArray(struct)){return false}

		for(let i = 0; i < struct.length; i++){
			if(!found){
				const team = struct[i];
				if(team.id === teamId){
					found = true;
					struct[i] = null;
					break;
				}
				else{
					if(Array.isArray(team.children) && team.children.length > 0){
						found = removeTeamFromStructure(teamToDelete, team.children)
					}
				}
			}
			
		}
		return found;
	}
	const cleanupStructure = (struct: TeamObject[]) => {
		const copy = [...struct];
		struct.length = 0;
		for(let i = 0; i < copy.length; i++){
			const team = copy[i];
			if(team !== null){
				struct.push(team)
				if(Array.isArray(team.children) && team.children.length > 0){
					cleanupStructure(team.children)
				}
			}
		}
	}
	
	const removedSlots: TeamSlot[] = [];
	if(teamToDelete){
		const slotsCopy = [...teamToDelete.slots]
		const result = removeTeamFromStructure(teamToDelete, collection.selectors.focused.value.structure)
		cleanupStructure(collection.selectors.focused.value.structure)
		
		slotsCopy.forEach(slot => removedSlots.push(removeSlot(slot)))
		
		// console.log("After delete", collection.selectors.focused.value.structure, result)
	}
	// Object.keys(teamToDelete).forEach(key => teamToDelete[key] = null);
	return [removedSlots]
}

/**
 * Generates a new slot, adds it to local pulse storage, then returns the resulting slot if there are no errors 
 * @param role The role you would like this slot to have
 * @param isLeadership Is the role is a leadership position
 * @param requirements The requirements of the slot (will be defined later)
 * @param parentId The ID of the parent team
 */
export function generateSlot(role: string, isLeadership: boolean, requirements: string, parentId: number): TeamSlot{
	/**
	 * This checked to see if the ID of len of slots is already there. If so, it adds an offset. This is recursive and will keep trying until it gets an ID that is not in the slots
	 * @param offset the offset amount to add to the id
	 */
	const findNewId = (offset: number=0) => {
		const new_id = ( collection.selectors.focused.value.slots.length )  + offset;
		console.log(new_id)
		if (!collection.selectors.focused.value.slots.find((slot) => slot.id === new_id)) { return new_id }
		return findNewId(offset+1) 
	}
	const newSlot = {
		id: findNewId(),
		role: role,
		position: collection.selectors.focused.value.slots.length + 1,
		isLeadership: isLeadership,
		requirements,
	}
	addSlot(newSlot, parentId);
	return newSlot;
}

export function generateTeam(name: string, parentId?: number){
	const teams = flattenByProp(collection.selectors.focused.value.structure)
	/**
	 * This checked to see if the ID of len of slots is already there. If so, it adds an offset. This is recursive and will keep trying until it gets an ID that is not in the slots
	 * @param offset the offset amount to add to the id
	 */
	function findNewId (offset: number=0) {
		
		const new_id = teams.length + offset;
		const existingTeam = teams.find((group) => group?.id === new_id)
		if(!existingTeam){ return new_id }
		else { return findNewId(offset+1) }

	}
	
	const newTeam: TeamObject = {
		id: findNewId(),
		slots: [],
		children: [],
		name: name,
		position: 0,
		autoExpandSlot: [],
	}

	const team: any = teams.find((group: TeamObject) => Number(group.id) === parentId)
	if(team?.children === null){ team.children = [] }

	if(parentId > -1){
		teams.find(team => team.id === parentId).children.push(newTeam)
	} else{
		collection.selectors.focused.value.structure.push(newTeam)
	}
	return newTeam;
}

/**
 * Generates and adds an event player to the focused event. If a player with the same ID already exists, it modifies the player's slot id. It also returns the player object.
 * @param id The ID of the player
 * @param name The Name of the Player
 * @param slotId The SlotID associated with the player for this event
 */
export function generateEventPlayer(id: string, name: string, slotId?: number): EventPlayer{
	const myId: string = id;
	const player = collection.selectors.focused.value.players.find((player) => player.playerId === myId)
	
	if(slotId===undefined) {slotId = -1}
	if(player){
		// the player is in another slot
		console.log('Existing player found...')
		if(slotId){player.slotId = slotId}
		return player;
	}
	else{
		// the player does not exist in this event
		console.log('New player added!')
		const newPlayer = {
			playerId: myId,
			eventId: collection.selectors.focused.value.id,
			slotId,
			name,
			isPresent: false,
			comment: null
		}
		collection.selectors.focused.value.players.push(newPlayer);
		return newPlayer;
		// addPlayer(newPlayer);
	}
}
export function normalizeEventDetails(eventId: number, payload: EventProto){
	const {name, type, description, report, date, squadron, controllers, status, isPublished} = payload
	if(eventId){
		const event = collection.getValueById(eventId)
		const result =  {
			id: eventId,
			name: name||event.name,
			type: type||event.type,
			description: description||event.description,
			report: report||event.report,
			date: date||event.date,
			squadron: squadron||event.squadron,
			controllers: controllers||event.controllers,
			status: status||event.status,
			isPublished: isPublished||event.isPublished,
		}
		// if(Array.isArray(result.squadron)){result.squadron = result.squadron.map(controller => controller.id)}
		return result;
	}
}
